import { render } from "./ProfileLayoutMinimal.vue?vue&type=template&id=6db9d297&scoped=true"
import script from "./ProfileLayoutMinimal.vue?vue&type=script&lang=js"
export * from "./ProfileLayoutMinimal.vue?vue&type=script&lang=js"

import "./ProfileLayoutMinimal.vue?vue&type=style&index=0&id=6db9d297&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db9d297"]])

export default __exports__